export default __webpack_public_path__ + "static/media/paulana-lamonier-320.ce894ef8.jpg";